/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, doT) {
	'use strict';
	/*jshint smarttabs:false */
	/**
	 * Address with Type-Ahead uses the GAIA Webservice to
	 * render list of suggestions to the user using the address
	 * fields in this set.
	 *
	 * As the M@p Service will be removed from portal as of November 2016, pre-fill from
	 * M@p values has been removed from this component.
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.AutoSuggestAddress
	 * @class AutoSuggestAddress
	 * @extends Tc.Module
	 *
	 * @terrificjs-channels    autosuggestaddress
	 * @fires zipCityLoaded, zipCityStart
	 * @handles onZipCityLoaded
	 */

	var GAIA = {
			SERVICE: {
				BASE_PATH: '/portal-services/portal-integration/ws/gaia/',
			},
		},
		// P = postal addresses
		// S = Official addresses
		// T = Technical addresses
		ADDRESS_TYPE = {
			"P": "&addressUsage=P",
			"S": "&addressUsage=S",
			"T": "&addressUsage=T",
			"PS": "&addressUsage=PS",
			"ST": "&addressUsage=ST",
			"PST": "&addressUsage=PST",
		},
		ERROR_MESSAGES = {
			400: 'bad request, mandatory input parameters missing',
			401: 'unauthorized - authorization informations missing',
			404: 'not found',
			500: 'internal server error'
		},
		LIST_MAX_LENGTH = 10,
		dataCache = {
			zipCity: [],
			streetName: [],
			houseNumber: [],
			houseName: []
		},
		KEYS = {
			ESCAPE: 27,
			DOWN: 40,
			UP: 38,
			ENTER: 13,
			TAB: 9
		},
		FIELD_MAPPINGS = {
			zip: {datakey: 'zipCity', valuekey: 'zipCity', matchStart: true},
			city: {datakey: 'zipCity', valuekey: 'zipCity', matchStart: false},
			streetName: {datakey: 'streetName', valuekey: 'streetName', matchStart: false},
			houseNumber: {datakey: 'houseNumber', valuekey: 'houseNumber', matchStart: true},
			houseName: {datakey: 'houseName', valuekey: 'houseName', matchStart: false}
		};

	function escapeRegExp(string) {
		// copied from Tc.Module.ScForm.js
		return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	}

	Module.AutoSuggestAddress = Module.extend({
		on: function (callback) {
			this.templateCache = {};

			this.initComponent();
			this.cacheTemplates();

			this.typeAheadList = this.$ctx.find('.type-ahead-list');
			this.typeAheadListUl = this.typeAheadList.find('ul');
			this.isMobile = this.$ctx.is('isMobile');
			this.addressType = this.$ctx.data('address-type');
			if (!(this.addressType in ADDRESS_TYPE)) {
				this.addressType = 'PS'; // default
			}

			this.addEventListeners();
			this.setFieldAccess();
			callback();
		},

		/**
		 * Initialize Component, and make sure it can be easily overridden by
		 * a skin.
		 */
		initComponent: function () {
			this.$checkboxNoStreet = this.$ctx.find('.nostreet input:checkbox');
			this.$zipAndCity = this.$ctx.find('.zip-and-city');
			this.$zipInput = this.$zipAndCity.find('.zip input');
			this.$cityInput = this.$zipAndCity.find('.city input');
			this.$streetNrAndHouseName = this.$ctx.find('input').not('.zip-and-city input, .nostreet input');
			this.$allAddressInputFields = this.$ctx.find('input').not('.nostreet input, [type="hidden"]');
			this.$streetAndNumber = this.$ctx.find('.street-and-nr');
			this.$streetNameInput = this.$streetAndNumber.find('.street-name input');
			this.$houseNumberInput = this.$streetAndNumber.find('.house-number input');
			this.$locationIdInput = this.$ctx.find('[name="locationId"]');
			this.$building = this.$ctx.find('.building');
			this.$houseNameInput = this.$building.find('.house-name input');
			this.formIsRequired = this.$ctx.data('formInputRequired');
			// Used in Custom Forms
			this.gaiaAdress = this.$ctx.hasClass('gaiaAddressCheck');

			if (this.gaiaAdress) {
				this.initAdditionalFields();
			}

		},

		initAdditionalFields: function () {
			var street, houseNumber, houseName, zipFieldName, cityFieldName;

			street = this.$streetNameInput.attr('name');
			houseNumber = this.$houseNumberInput.attr('name');
			houseName = this.$houseNameInput.attr('name');
			zipFieldName = this.$zipInput.attr('name');
			cityFieldName = this.$cityInput.attr('name');
			FIELD_MAPPINGS[street] = {datakey: 'streetName', valuekey: 'streetName', matchStart: false};
			FIELD_MAPPINGS[houseNumber] = {datakey: 'houseNumber', valuekey: 'houseNumber', matchStart: false};
			FIELD_MAPPINGS[houseName] = {datakey: 'houseName', valuekey: 'houseName', matchStart: false};
			FIELD_MAPPINGS[zipFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: true};
			FIELD_MAPPINGS[cityFieldName] = {datakey: 'zipCity', valuekey: 'zipCity', matchStart: false};
			this.$locationIdInput = this.$ctx.find('.gaiaId');
		},
		/**
		 * Cache the templates for each list item
		 */
		cacheTemplates: function () {
			this.templateCache[FIELD_MAPPINGS.zip.datakey] = doT.template(this.$ctx.find('script.tmpl-zipcity').html());
			this.templateCache[FIELD_MAPPINGS.streetName.datakey] = doT.template(this.$ctx.find('script.tmpl-streetname').html());
			this.templateCache[FIELD_MAPPINGS.houseNumber.datakey] = doT.template(this.$ctx.find('script.tmpl-housenumber').html());
			this.templateCache[FIELD_MAPPINGS.houseName.datakey] = doT.template(this.$ctx.find('script.tmpl-housename').html());
		},

		/**
		 * Adding all event listeners for this component
		 */
		addEventListeners: function () {
			this.$checkboxNoStreet.on('change', $.proxy(this.handleNoStreet, this));
			this.$ctx.on('mouseenter', $.proxy(this.handleFirstInteraction, this));
			this.typeAheadListUl.on('click', 'li:not(.nomatch)', $.proxy(this.handleListItemSelected, this));
			this.typeAheadList.on('mouseenter', $.proxy(this.handleListFocus, this));
			this.typeAheadList.on('mouseleave', $.proxy(this.handleListFocus, this));
			this.$allAddressInputFields.on('focusin.AutoSuggestAddress', $.proxy(this.handleFirstInteraction, this));
			this.$allAddressInputFields.on('focusin', $.proxy(this.handleInputFocusIn, this));
			this.$allAddressInputFields.on('blur', $.proxy(this.handleInputFocusOut, this));
			this.$houseNumberInput.on('input change', $.proxy(this.handleAddressComplete, this));
			this.$houseNameInput.on('input change', $.proxy(this.handleAddressComplete, this));
		},
		/**
		 * Adds key listeners to a form field.
		 * @param $input
		 */
		addKeyListeners: function ($input) {
			$input.on('input.AutoSuggestAddress', $.proxy(this.handleInput, this));
			$input.on('keydown.AutoSuggestAddress', $.proxy(this.handleKeyDown, this));
		},
		/**
		 * Cache the current input field value for later comparison to the new value,
		 * to figure out if the value changed.
		 * @param $input
		 */
		cacheInputFieldValue: function ($input) {
			var zipCityValue;

			if (this.isZipOrCity($input)) {
				zipCityValue = this.$zipInput.val() + ' ' + this.$cityInput.val();
				this.$zipInput.data('currentValue', zipCityValue);
				this.$cityInput.data('currentValue', zipCityValue);
			}
			else {
				$input.data('currentValue', $input.val());
			}
		},
		/**
		 * Clears the values of all subsequent input fields starting at the
		 * provided input field.
		 * @param fieldName
		 */
		clearSubsequentFields: function (fieldName) {
			var $input = this['$' + fieldName + 'Input'];
			if ($input) {
				var inputIndex = this.$allAddressInputFields.index($input);
				for (var i = (inputIndex + 1); i < this.$allAddressInputFields.length; i += 1) {
					this.$allAddressInputFields.eq(i).val('');
				}

				this.setFieldAccess();
			}
		},
		/**
		 * Remove the unique address id from the form
		 */
		clearUniqueAddressId: function () {
			this.$locationIdInput.val('');
		},
		/**
		 * checks if a (series) of fields already have values set an initiates loading of
		 * the according data for the next fields.
		 * @param fieldName
		 */
		checkForPreFilledValues: function (fieldName) {
			var $input, filterValue, filteredValues, links, dataLink;

			if (fieldName === 'zipCity') {
				filterValue = (this.$zipInput.val().length && this.$cityInput.val().length) ? this.$zipInput.val() + ' ' + this.$cityInput.val() : '';
			}
			else {
				$input = this['$' + fieldName + 'Input'] || $();
				filterValue = $input.val();
			}

			if (!filterValue || !filterValue.length) {
				if (fieldName !== 'zipCity') {
					$input.focus();
				}
				return;
			}

			filteredValues = this.getFilteredList(dataCache[fieldName], fieldName, filterValue, true, true);
			if (filteredValues.length) {
				links = filteredValues[0].links;
				if (fieldName === 'zipCity') {
					// cache the values in case the user switches from street name to house name
					this.zipCityValueCache = {
						zip: this.$zipInput.val(),
						city: this.$cityInput.val(),
						linkStreetName: this.getFilteredList(links, 'rel', 'streets', true, true)[0].href,
						linkHouseName: this.getFilteredList(links, 'rel', 'houseNames', true, true)[0].href
					};

					dataLink = (this.useHouseName) ? this.zipCityValueCache.linkHouseName : this.zipCityValueCache.linkStreetName;
				}
				else {
					dataLink = links[0].href;
				}

				if (dataLink) {
					this.getData(dataLink);
				}
			}
		},
		/**
		 * Checks if all fields have a value
		 */
		formIsComplete: function () {
			if (this.useHouseName) {
				return (this.$zipInput.val().length && this.$cityInput.val().length && this.$houseNameInput.val().length);
			}

			return (this.$zipInput.val().length && this.$cityInput.val().length && this.$streetNameInput.val().length && this.$houseNumberInput.val().length);
		},
		/**
		 * Handles all ajax calls to the backend.
		 *
		 * @param url
		 * @param successCallback
		 * @param params
		 */
		getData: function (url) {
			var requestUrl = GAIA.SERVICE.BASE_PATH + url;
			this.dataLoadingInProgress = true;
			$.ajax({
				url: requestUrl,
				success: $.proxy(this.handleDataSuccess, this),
				context: this,
				error: function (jqXHR, textStatus, errorThrown) {
					// jshint unused: false
					this.log('getData :: ajax error callback :: arguments', arguments);
					this.showErrorMessage(parseInt(jqXHR.status, 10));
				}
			});
		},
		/**
		 * Filters an array of objects.
		 * Selects all objects that have key and key contains value(s)
		 *
		 * @param list - (array)
		 * @param key - (string)
		 * @param value - (string|array). Values that a key must contain. In case of array, if any of the values are part of key, the element is returned
		 * @param matchStart - (boolean) indicate if the value to filter for should match the beginning of the string
		 * @param matchEnd - (boolean) indicate if the value to filter for should match the beginning of the string
		 * @param maxLength - (int) the max length of the array. can be undefined.
		 * @returns Array
		 */
		getFilteredList: function (list, key, value, matchStart, matchEnd, maxLength) {
			var i,
				valueRegexPrefix = (matchStart) ? '^' : '',
				valueRegexPostfix = (matchEnd) ? '$' : '';

			if ($.isArray(list)) {
				return $.grep(list, function (element) {
					if (!element.hasOwnProperty(key)) {
						return false;
					}

					if ($.isArray(value)) {
						for (i = 0; i < value.length; i += 1) {
							if (new RegExp(valueRegexPrefix + escapeRegExp(value[i]) + valueRegexPostfix, 'i').test(element[key].toString())) {
								return true;
							}
						}

						return false;
					}
					else {
						return new RegExp(valueRegexPrefix + escapeRegExp(value) + valueRegexPostfix, 'i').test(element[key].toString());
					}
				}).slice(0, maxLength); // slice to max length. if maxlength is undefined the whole array will be returned
			}

			return [];
		},
		/**
		 * Retrieve the next field in the row
		 * @param field
		 * @return jquery object - next input field
		 */
		getNextField: function (field) {
			if (!field) {
				return null;
			}
			var fieldName = field.attr('name');
			switch (fieldName) {
				case 'zip':
				case 'city':
					if (this.useHouseName) {
						return this.$houseNameInput;
					}
					return this.$streetNameInput;
				case 'streetName':
					return this.$houseNumberInput;
				default:
					return null;
			}
		},
		/**
		 * Handles when the last fields are filled/changed
		 */
		handleAddressComplete: function () {
			this.setUniqueAddressId();
		},

		/**
		 * Handles success for all data calls
		 * @param data
		 * @param status
		 * @param jqXHR
		 */
		handleDataSuccess: function (data) {
			var nextField;
			this.dataLoadingInProgress = false;
			if (data.length) {
				if (data[0].hasOwnProperty('zipCity') && !data[0].hasOwnProperty('houseNumber')) {
					// now store the zip and city data for this instance,
					// but filter out P.O. Box and company addresses first (zipTypes 30 and 40 must go out)
					dataCache.zipCity = this.getFilteredList(data, 'zipType', ['10', '20'])
					// filter entries that are not prefixed with an actual zip number
					// eg. {zipCity: "Wilen b. Wollerau", zipType: 20, altName: "n", zipCode6Pos: "883202"}
					// vs. {zipCity: "8832 Wilen b. Wollerau", zipType: 20, altName: "n", zipCode6Pos: "883202"}
						.filter(function (zipCity) {
							return zipCity.zipCity.match(/^\d+\s/);
						});

					// Send this big junk of data off to all other instances on the page
					// so they don't have to load it themselves.
					this.fire('zipCityLoaded', {zipCity: dataCache.zipCity});
					this.checkForPreFilledValues('zipCity');
					this.clearSubsequentFields('city');
					if (this.activeField) {
						this.updateList(this.activeField);
					}
				}
				else if (data[0].hasOwnProperty('streetName')) {
					dataCache.streetName = data;
					this.checkForPreFilledValues('streetName');
					this.clearSubsequentFields('streetName');
				}
				else if (data[0].hasOwnProperty('houseName')) {
					dataCache.houseName = data;
					this.checkForPreFilledValues('houseName');
				}
				else if (data[0].hasOwnProperty('houseNumber')) {
					dataCache.houseNumber = data;
					this.checkForPreFilledValues('houseNumber');
				}
			}
			else {
				// set focus to the next field.
				nextField = this.getNextField(this.activeField);
				if (nextField) {
					nextField.focus();
				}
				else if (this.activeField) {
					this.activeField.focusout();
				}
			}
		},
		/**
		 * Loading the zip/city json data on first interaction and sending it
		 * off to any other instance of this component on the page.
		 * @param event
		 */
		handleFirstInteraction: function () {
			// prepare initial url
			var url = 'zip-cities/domicile';
			// immediately remove the event handlers that triggered this method, so it won't be called twice
			this.removeFirstInteractionHandlers();
			// let other instances know they can remove the event listeners as well, to avoid loading the data twice
			this.fire('zipCityStart');
			// load the data
			this.getData(url);
		},
		/**
		 * Handles when an input field gains focus
		 * @param event
		 */
		handleInputFocusIn: function (event) {
			var $input = $(event.target);
			// simply cache the current value to verify if the value changed, when focus is lost
			this.cacheInputFieldValue($input);
			this.activeField = $input;
			this.moveListToField($input);
			this.addKeyListeners($input);
			this.updateList($input);
		},
		/**
		 * Handles when an input field loses focus
		 * @param event
		 */
		handleInputFocusOut: function (event) {
			var $input = $(event.target);
			this.removeKeyListeners($input);

			if (this.inputValueChanged($input) && !this.dataLoadingInProgress && !this.valueSetFromListSelect) {
				// input values changed, clear the fields behind this one.
				this.clearSubsequentFields($input.attr('name'));
			}
			this.valueSetFromListSelect = false;
			this.hideTypeAheadList();
		},

		/**
		 * Key events need to be handled on key down to be able to
		 * intercept the event before the browser acts on it.
		 * @param event
		 */
		handleKeyDown: function (event) {
			var $listItems = this.typeAheadListItems;
			var $focus = $listItems.filter('.focus');
			var $input = $(event.target);
			switch (event.which) {
				case KEYS.TAB:
					if (this.listHasFocus) {
						if ($focus.length) {
							event.preventDefault();
							$focus.click();
						}
					}
					break;
				case KEYS.ENTER:
					if (this.listHasFocus) {
						if ($focus.length) {
							event.preventDefault();
							$focus.click();
						}
					}
					break;
				case KEYS.DOWN:
					event.preventDefault();
					this.showTypeAheadList();
					this.selectListItem(true);
					break;
				case KEYS.UP:
					event.preventDefault();
					this.showTypeAheadList();
					this.selectListItem(false);
					break;
				case KEYS.ESCAPE:
					if (!this.typeAheadList.hasClass('hidden')) {
						event.preventDefault();
						$listItems.removeClass('focus');
						this.typeAheadList.addClass('hidden');
						this.typeAheadList.focus();
						this.listHasFocus = false;
					}
					break;
				default:
					this.updateList($input);
					this.setFieldAccess();
			}
		},

		/**
		 * Input event is fired on e.g. paste
		 * @param event
		 */
		handleInput: function (event) {
			var $input = $(event.target);
			this.updateList($input);
			this.setFieldAccess();
		},

		/**
		 * Handles list focus. Sets a flag (listHasFocus) to keep track of the list focus.
		 * @param event
		 */
		handleListFocus: function (event) {
			this.listHasFocus = (event.type === 'mouseenter');
		},
		/**
		 * Handles a selected list item
		 * @param event
		 */
		handleListItemSelected: function (event) {
			var listItem = $(event.target),
				value = listItem.text(), values, dataLink;

			if (this.isZipOrCity(this.activeField)) {
				values = value.split(' ');
				this.$zipInput.val(values.shift()); // first value is the zip
				this.$cityInput.val(values.join(' ')); // all others the city
				dataLink = (this.useHouseName) ? listItem.data('linkHouseName') : listItem.data('linkStreetName');

				var changed = (!this.zipCityValueCache)
					|| (this.zipCityValueCache.zip !== values[0])
					|| (this.zipCityValueCache.city !== values[1]);

				// cache the values in case the user switches from street name to house name
				this.zipCityValueCache = {
					zip: values[0],
					city: values[1],
					linkStreetName: listItem.data('linkStreetName'),
					linkHouseName: listItem.data('linkHouseName')
				};

				if (changed) {
					if (this.$houseNameInput) {
						this.$houseNameInput.val('').trigger('change');
					}
					if (this.$houseNumberInput) {
						this.$houseNumberInput.val('').trigger('change');
					}
					if (this.$streetNrAndHouseName) {
						this.$streetNrAndHouseName.val('').trigger('change');
					}
				}

			}
			else {
				this.activeField.val(value).trigger('change');
				dataLink = listItem.data('link');
			}

			if (dataLink) {
				this.getData(dataLink);
			}

			this.setFieldAccess();
			this.listHasFocus = false;
			this.valueSetFromListSelect = true;
			this.hideTypeAheadList();
		},
		/**
		 * Toggling the UI between Street/Nr. and House Name entry fields.
		 * @param event
		 */
		handleNoStreet: function (event) {
			var isChecked = $(event.target).is(':checked'),
				showField = (isChecked) ? this.$building : this.$streetAndNumber,
				hideField = (isChecked) ? this.$streetAndNumber : this.$building;

			showField.removeClass('hidden');
			hideField.addClass('hidden');

			if (this.formIsRequired) {
				showField.find('input').prop('required', true).prop('aria-required', true);
				hideField.find('input').prop('required', false).prop('aria-required', false);
			}

			// store the option for later use, when evaluating the data
			this.useHouseName = isChecked;

			// clear the input values in the field to hide, so they won't be submitted with the form.
			hideField.find('input').val('').trigger('change');

			// if any of the data sets are empty, load the appropriate data set from the GAIA service for the type ahead list:
			if (this.zipCityValueCache) {
				if (this.useHouseName && dataCache.houseName.length === 0) {
					this.getData(this.zipCityValueCache.linkHouseName);
				}
				else if (!this.useHouseName && dataCache.streetName.length === 0) {
					this.getData(this.zipCityValueCache.linkStreetName);
				}
			}
		},
		/**
		 * Hides the type ahead list
		 */
		hideTypeAheadList: function () {
			if (!this.listHasFocus) {
				this.typeAheadList.addClass('hidden');
				this.typeAheadListUl.empty();
				this.listHasFocus = false;
			}
		},
		/**
		 * Figure out if the value has changed.
		 * @param $input
		 * @returns {boolean}
		 */
		inputValueChanged: function ($input) {
			var newFieldValue;

			if (this.isZipOrCity($input)) {
				newFieldValue = this.$zipInput.val() + ' ' + this.$cityInput.val();
			}
			else {
				newFieldValue = $input.val();
			}

			return $input.data('currentValue') !== newFieldValue;
		},
		/**
		 * Is the provided input field the zip or city field
		 * @param $input
		 * @returns {boolean}
		 */
		isZipOrCity: function ($input) {
			var fieldName = $input.attr('name');
			if (this.gaiaAdress) {
				return $input.attr('name') === this.$zipInput.attr('name') ||
					$input.attr('name') === this.$cityInput.attr('name');
			} else {
				return (fieldName === 'zip' || fieldName === 'city');
			}

		},
		/**
		 * moving the list to a input field
		 * @param input - the input field to move the list to
		 */
		moveListToField: function (input) {
			var field = input.closest('.field'),
				$sdxMessagePart = field.find('.sdx.message'),
				position = field.position(),
				positionTop = position.top + parseInt(field.innerHeight(), 10) - parseInt(input.css('margin-bottom'), 10) -
					parseInt($sdxMessagePart.length ? $sdxMessagePart.innerHeight() : 0, 10);

			this.typeAheadList.css({left: position.left, top: positionTop, minWidth: input.outerWidth()});

			// we only want to add scrollbar if the fields are in the order overlay
			if ($('.modOrderOverlay').length) {
				if (field.parent().hasClass('zip-and-city')) {
					this.typeAheadList.addClass('city-position').removeClass('street-position');
				}
				else if (field.parent().hasClass('street-and-nr')) {
					this.typeAheadList.addClass('street-position').removeClass('city-position');
				}
			}
		},
		/**
		 * Terrific event handler for the fillFormWithStorageData message.
		 * Prefills the form with data provided from storage data.
		 * @param data
		 */
		onFillFormWithStorageData: function (data) {
			if (!this.formAutoFilled) {
				if (data.nostreet && data.nostreet !== false) {
					this.$checkboxNoStreet.prop('checked', true).trigger('change');
				}

				for (var field in data) {
					if (field === 'nostreet') {
						continue;
					}
					var input = this['$' + field + 'Input'];
					if (input) {
						input.val(data[field]).trigger('change');
					}
				}

				this.setFieldAccess();
				this.formAutoFilled = true;
			}
		},
		/**
		 * Terrific event handler for the zipCityLoaded message
		 * Stores the zip and city data locally and removes the
		 * hover focus handler for this instance.
		 */
		onZipCityLoaded: function (data) {
			dataCache.zipCity = data.zipCity;
		},
		/**
		 * Terrific event handler for the zipCityStart message.
		 */
		onZipCityStart: function () {
			// another instance of this module already started loading the zip and city data
			// so we can remove the event listeners that would trigger the loading.
			this.removeFirstInteractionHandlers();
		},
		/**
		 * Removes the mouseenter and focus handlers
		 */
		removeFirstInteractionHandlers: function () {
			this.$ctx.off('mouseenter');
			this.$allAddressInputFields.off('focusin.AutoSuggestAddress');
		},
		/**
		 * Removes key listeners from a form field.
		 * @param $input
		 */
		removeKeyListeners: function ($input) {
			$input.off('input.AutoSuggestAddress');
			$input.off('keydown.AutoSuggestAddress');
		},
		/**
		 * Selecting the next or previous item in the currently open list
		 * @param selectNextItem - (boolean) - whether the go down or up in the list
		 */
		selectListItem: function (selectNextItem) {
			var selectedItem = this.typeAheadListItems.filter('.focus'),
				listLength = this.typeAheadListItems.length,
				step = (selectNextItem) ? 1 : -1,
				nextIndex;

			if (selectedItem.length) {
				nextIndex = (selectedItem.index() + step) % listLength;
			}
			else {
				nextIndex = (selectNextItem) ? 0 : -1;
			}

			this.typeAheadListItems.removeClass('focus');
			this.typeAheadListItems.eq(nextIndex).addClass('focus');

			if (!this.listHasFocus) {
				this.listHasFocus = true;
			}
		},
		/**
		 * Sets the access to the appropriate fields.
		 * if the zip or city doesn't have a value, it will disable the other fields.
		 */
		setFieldAccess: function () {
			if (this.$zipInput.val().length && this.$cityInput.val().length) {
				this.$houseNameInput.prop('disabled', false);
				this.$streetNameInput.prop('disabled', false);

				if (this.$streetNameInput.val().length) {
					this.$houseNumberInput.prop('disabled', false);
				} else {
					this.$houseNumberInput.prop('disabled', true);
					this.$houseNumberInput.val('').trigger('change');
				}
			}
			else {
				this.$streetNrAndHouseName.prop('disabled', true);
				this.$houseNameInput.prop('disabled', true);
				this.$streetNrAndHouseName.val('').trigger('change');
				this.$houseNameInput.val('').trigger('change');
			}
		},
		/**
		 * Add the unique address id to the form
		 * @param uniqueAddressId - unique address id as provided by GAIA
		 */
		setUniqueAddressId: function () {
			var field = (this.useHouseName) ? this.$houseNameInput : this.$houseNumberInput,
				filteredValues;
			// add unique address id to the form
			if (field.val()) {
				if (this.gaiaAdress) {
					if (this.useHouseName) {
						filteredValues = this.getFilteredList(dataCache.houseName, 'houseName', field.val(), true, true);
					} else {
						filteredValues = this.getFilteredList(dataCache.houseNumber, 'houseNumber', field.val(), true, true);
					}
				}
				else {
					filteredValues = this.getFilteredList(dataCache[field.attr('name')], field.attr('name'), field.val(), true, true);
				}

				if (filteredValues.length && filteredValues[0].hasOwnProperty('uniqueAddressId')) {
					this.$locationIdInput.val(filteredValues[0].uniqueAddressId);
					if(this.gaiaAdress) {
						this.$locationIdInput.prop('disabled', false);
					}
				}
				else {
					this.clearUniqueAddressId();
				}
			}
		},

		/**
		 * Shows a customized error Code based on the error status code
		 * Currently no UI is present to display the message to the user.
		 * @param statusCode
		 */
		showErrorMessage: function (statusCode) {
			var message = ERROR_MESSAGES[statusCode] || 'None';
			this.log('showErrorMessage :: Status Code: ' + statusCode + ' | Message: ' + message);
		},

		/**
		 * Displays the type ahead list
		 */
		showTypeAheadList: function () {
			if (this.activeField) {
				if ((!this.activeField.val() && this.typeAheadListItems.length >= 1) || (this.activeField.val() && this.typeAheadListItems.length)) {
					this.typeAheadList.removeClass('hidden');
				}
			}
		},

		/**
		 * Update the type-ahead list with new values
		 * @param $input
		 */
		updateList: function ($input) {
			var value = $input.val(),
				fieldName = $input.attr('name'),
				fieldMap = FIELD_MAPPINGS[fieldName],
				dataSet = dataCache[fieldMap.datakey],
				filteredSet = this.getFilteredList(dataSet, fieldMap.valuekey, value, fieldMap.matchStart, false, LIST_MAX_LENGTH),
				listHtml = this.templateCache[fieldMap.datakey](filteredSet);

			this.typeAheadListUl.html(listHtml);
			// cache list items
			this.typeAheadListItems = this.typeAheadListUl.find('li');
			if (fieldName === 'houseNumber' && filteredSet.length < 1) {
				this.valueSetFromListSelect = false;
				this.hideTypeAheadList();
			} else {
				this.showTypeAheadList();
			}
		}
	});

	// Guards execution of the named accessors against the specified guardProperty
	// (property must be falsy for the methods to be executed)
	function guardable(module, accessors, guardProperty) {
		module = module.prototype;
		module[guardProperty] = false;
		$.each(accessors, function (i, accessorName) {
			var orig = module[accessorName];
			var guard = function () {
				if (this[guardProperty]) {
					return;
				}
				return orig.apply(this, arguments);
			};
			guard.displayName = 'guard-' + (orig.displayName || orig.name);
			module[accessorName] = guard;
		});
	}

	guardable(
		Module.AutoSuggestAddress,
		[
			'handleNoStreet',
			'handleListItemSelected',
			'handleListFocus',
			'handleFirstInteraction',
			'handleInputFocusIn',
			'handleInputFocusOut',
			'handleAddressComplete',
			'handleKeyDown',
			'handleInput'
		],
		'disableAutosuggest'
	);


	Module.AutoSuggestAddress.FIELD_MAPPINGS = FIELD_MAPPINGS;
	if (window.QUnit) {
		Module.AutoSuggestAddress.reset = function () {
			dataCache = {
				zipCity: [],
				streetName: [],
				houseNumber: [],
				houseName: []
			};
		};
	}

}(window.Tc.Module, window.Tc.$, window.doT));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.AutoSuggestAddress.js
// module id = 268
// module chunks = 0